import React from 'react'
import { useNavigate } from 'react-router-dom';
import SelectionCard from '../../components/SelectionCard';
import LayoutHeader from '../../layout/LayoutHeader';

export default function AddSection() {
    const navigate = useNavigate();

    return (
        <LayoutHeader>
            <div className="w-[390px] flex flex-col justify-start items-center relative z-[0]">
                <div className='px-4 my-[50px] flex w-full justify-between'>
                    <p className='text-white' style={{ fontSize: '12px' }}>Add a module</p>
                    <p onClick={() => navigate('/main')} className='text-white cursor-pointer' style={{ fontSize: '12px' }}>Go back</p>
                </div>
                <SelectionCard 
                    txt="Custom" 
                    description="Create your own layout"
                    link="/add-section/custom" 
                    dotimgclss={false} 
                    indicator={<div className="h-[6px] w-[6px] rounded-full bg-red-500 ml-2" />} 
                />
                <SelectionCard 
                    txt="Music" 
                    description="Embed your latest songs or albums"
                    link="/add-section/add-music" 
                    dotimgclss={false} 
                />
                <SelectionCard 
                    txt="Video" 
                    description="Showcase a Youtube or exclusive video"
                    dotimgclss={false} 
                    link="/add-section/add-video-link" 
                />
                <SelectionCard 
                    txt="Event" 
                    description="Add a your date or pop-up"
                    dotimgclss={false} 
                    link={"/add-section/add-event"} 
                />
                <SelectionCard 
                    txt="Product" 
                    description="Feature merch or other items"
                    dotimgclss={false} 
                    link={"/add-section/add-product"} 
                />
                <SelectionCard 
                    txt="Playlist" 
                    description="Link a Spotify or Apple Music playlist"
                    dotimgclss={false} 
                    link={"/add-section/add-playlist"} 
                />
                <SelectionCard 
                    txt="Social feed" 
                    description="Link your social media posts"
                    dotimgclss={false} 
                    link={"/add-section/add-social-feed"} 
                />
                <div className="hidden">
                    <SelectionCard 
                        txt="Form" 
                        description="Add a form for your users to submit"
                        dotimgclss={false} 
                        link={"/add-section/add-form"} 
                    />
                    <SelectionCard txt="Custom link" dotimgclss={false} link={"/add-section/add-custom-link"} />
                    <SelectionCard txt="Video Message" link="/add-section/video-message" dotimgclss={true} />
                </div>
            </div>
        </LayoutHeader>
    );
}
